<script setup lang="ts">
const props = defineProps<{
  video: {
    src: string
    type: string
  }
}>()
</script>

<template>
  <ApplicationPageHeader class="overflow-hidden">
    <video autoplay muted loop disableremoteplayback class="absolute left-0 top-0 size-full object-cover opacity-60 mix-blend-multiply grayscale">
      <source :src="props.video.src" :type="props.video.type">
    </video>
    <div class="relative z-10 flex h-full items-center justify-center">
      <slot />
    </div>
  </ApplicationPageHeader>
</template>
